import { eventStreamService } from 'core-roblox-utilities';

const { eventTypes } = eventStreamService;
const VERIFIED_SIGNUP = 'MultiverseSignUpForm';

const events = {
  DefaultVerifiedSignupOrigin: 'WebVerifiedSignup',

  emailFocused: {
    name: 'emailFocused',
    context: VERIFIED_SIGNUP,
    type: eventTypes.formInteraction,
    params: {
      aType: 'focus',
      field: 'email'
    }
  },
  phoneFocused: {
    name: 'phoneFocused',
    context: VERIFIED_SIGNUP,
    type: eventTypes.formInteraction,
    params: {
      aType: 'focus',
      field: 'phone'
    }
  },
  useEmail: {
    name: 'useEmail',
    context: VERIFIED_SIGNUP,
    type: eventTypes.formInteraction,
    params: {
      aType: 'click',
      field: 'useEmail'
    }
  },
  usePhone: {
    name: 'usePhone',
    context: VERIFIED_SIGNUP,
    type: eventTypes.formInteraction,
    params: {
      aType: 'click',
      field: 'usePhone'
    }
  }
};

export { events as default };
